import { render, staticRenderFns } from "./Create-Account.vue?vue&type=template&id=3bd328e3&scoped=true&"
import script from "./Create-Account.vue?vue&type=script&lang=js&"
export * from "./Create-Account.vue?vue&type=script&lang=js&"
import style0 from "./Create-Account.vue?vue&type=style&index=0&id=3bd328e3&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3bd328e3",
  null
  
)

export default component.exports